import {ModuleConfiguration} from "../router/model/UserPermission";
import {LqbPricerParamsServiceModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const LqbPricerParametersServiceModule = new ModuleConfiguration(
    LqbPricerParamsServiceModuleName,
    [AngularJsMaterialModuleName]);